import React, { ButtonHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@utex/ui-kit';
import { Container, Icon, Item as ItemEmotion } from './styles';
import { NumberView } from '../NumberView';

export interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: string;
  name: string;
  description?: string;
  isActive: boolean;
  fee: number | undefined;
}

export type MenuProps = Omit<Props, 'icon' | 'name' | 'description'>;

export const MenuItem: React.FC<Props> = ({ fee, name, icon, description, ...props }) => {
  const { t } = useTranslation('deposit');
  return (
    <Container>
      <ItemEmotion type="button" {...props}>
        <Box display="flex" alignItems="center">
          <Icon src={icon} alt={name} />
          <Box display="flex" flexDirection="column">
            <Typography.Text size={{ all: 'L', phonablet: 'M' }}>{name}</Typography.Text>
            <Typography.Text size={{ all: 'M', phonablet: 'XS' }} view="hint">
              {typeof fee === 'number' ? (
                <>
                  {t('Commission')} <NumberView>{fee}</NumberView>%
                </>
              ) : (
                description
              )}
            </Typography.Text>
          </Box>
        </Box>
      </ItemEmotion>
    </Container>
  );
};
